import script from "./date-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./date-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./date-widget-ly.vue?vue&type=style&index=0&id=c2b20044&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b20044"]])

export default __exports__